import { Builder, withChildren } from "@builder.io/react";
import {
  standardThemes,
  CTAButton,
  Banner100,
  TileContent,
  TileCTA,
  TileCategory,
  LanguageSwitcher,
} from "@orlandohealth/build-kit";
import { ErWaitTime } from "@orlandohealth/build-kit";

// This file is for deprecated components that are no longer used but are still in the Builder registry
// These components are hidden from the insert menu and are not used in the new design

// Register "CTA Button Component - HIDDEN

import { PlaceHolder } from "@orlandohealth/build-kit";


Builder.registerComponent(PlaceHolder, {
  hideFromInsertMenu: true,
  name: "InstantSearch",
  inputs: [
    {
      name: "name",
      type: "string",
      required: true,
      defaultValue: "InstantSearch",
    },
  ],
});

Builder.registerComponent(CTAButton, {
  name: "CTA Button",
  hideFromInsertMenu: true,
  inputs: [
    {
      name: "ctaText",
      type: "string",
      required: true,
      defaultValue: "[Learn More]",
    },
    {
      name: "href",
      type: "string",
      required: true,
      defaultValue: "[Link]",
    },
    {
      name: "theme",
      type: "string",
      required: true,
      defaultValue: "accent",
      enum: standardThemes,
    },
  ],
});

Builder.registerComponent(CTAButton, {
  name: "CTAButton2",
  hideFromInsertMenu: true,
  inputs: [
    {
      name: "theme",
      type: "string",
      required: true,
      defaultValue: "accent",
      enum: standardThemes,
    },
    {
      name: "ctaText",
      type: "string",
      required: true,
      defaultValue: "[Learn More]",
    },
    {
      name: "href",
      type: "string",
      required: true,
      defaultValue: "[Link]",
    },
  ],
});

// Register Tile Content Component - HIDDEN
Builder.registerComponent(withChildren(TileContent), {
  name: "Tile Content",
  hideFromInsertMenu: true,
  childRequirements: {
    message: "You can only add CTA Buttons",
    query: {
      "component.name": { $in: ["CTAButton"] },
    },
  },
  inputs: [
    {
      name: "theme",
      type: "string",
      required: true,
      defaultValue: "light",
      enum: standardThemes,
    },
    {
      name: "headline",
      type: "string",
      required: true,
      defaultValue: "[Title]",
    },
    {
      name: "subheadline",
      type: "string",
      defaultValue: "[Subheading]",
    },
    {
      name: "image",
      type: "file",
      required: false,
    },
    {
      name: "body",
      type: "html",
      required: true,
      defaultValue: "[Description]",
    },
  ],
});

// Register Tile CTA Component
Builder.registerComponent(TileCTA, {
  hideFromInsertMenu: true,
  name: "Tile CTA",
  inputs: [
    {
      name: "headline",
      type: "string",
      required: true,
      defaultValue: "[Headline]",
    },
    { name: "body", type: "string", required: true, defaultValue: "[Body]" },
    {
      name: "ctaText",
      type: "string",
      required: true,
      defaultValue: "[Learn More]",
    },
    { name: "ctaHref", type: "string", required: true, defaultValue: "#" },
    {
      name: "theme",
      type: "string",
      required: true,
      defaultValue: "light",
      enum: standardThemes,
    },
  ],
});

Builder.registerComponent(Banner100, {
  name: "Banner 100",
  hideFromInsertMenu: true,
  inputs: [],
});

// Register TileCategory Component
Builder.registerComponent(TileCategory, {
  name: "Tile Category",
  hideFromInsertMenu: true,
  inputs: [
    {
      name: "theme",
      type: "string",
      required: true,
      defaultValue: "light",
      enum: standardThemes,
    },
    {
      name: "image",
      type: "file",
      required: true,
    },
    {
      name: "headline",
      type: "string",
      required: true,
      defaultValue: "[Title]",
    },
    {
      name: "body",
      type: "text",
      required: true,
    },
    {
      name: "ctaText",
      type: "string",
      required: true,
      defaultValue: "Learn More",
    },
    {
      name: "href",
      type: "string",
      required: true,
    },
  ],
});

// Register Er Wait Time Component
Builder.registerComponent(ErWaitTime, {
  name: "Er Wait Time",
  hideFromInsertMenu: true,
  inputs: [
    {
      name: "className",
      type: "string",
    },
  ],
});

// Language Switcher Component
Builder.registerComponent(LanguageSwitcher, {
  name: "LanguageSwitcher",
  hideFromInsertMenu: true,
  inputs: [],
});
